<template>
  <div
    id="navigation-recents"
    class="the-navigation__panel"
    role="region"
    aria-label="Recentes"
    :style="placement"
    @focusout="focusOut"
  >
    <header class="the-navigation__panel-header">
      <b>Recentes</b>
      <button
        type="button"
        class="the-navigation__tool"
        :aria-label="mobile ? 'Voltar ao menu' : 'Fechar recentes'"
        @click="$emit('close', true)"
      >
        <i
          class="fas"
          :class="mobile ? 'fa-arrow-left' : 'fa-times'"
          aria-hidden="true"
        />
      </button>
    </header>

    <section
      v-for="day in days"
      :key="day.label"
    >
      <p class="the-navigation__panel-label">
        {{ day.label }}
      </p>
      <ul class="the-navigation__results">
        <NavigationItem
          v-for="route in day.items"
          :key="route.href"
          :route="route"
        />
      </ul>
    </section>

    <p
      v-if="!days.length"
      class="the-navigation__empty"
    >
      As telas que você visitar aparecem aqui.
    </p>
  </div>
</template>

<script>
import NavigationItem from '@/components/Navigation/NavigationItem.vue';
import { recentsPanelPlacement } from '@/utils/navigationMenu';

export default {
  name: 'NavigationRecents',
  components: {
    NavigationItem,
  },
  props: {
    days: {
      type: Array,
      required: true,
    },
    frame: {
      type: HTMLElement,
      required: true,
    },
    anchor: {
      type: HTMLElement,
      default: null,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    placement: {},
  }),
  created() {
    this.placement = this.measure();
  },
  mounted() {
    document.addEventListener('click', this.outside, true);
    window.addEventListener('keydown', this.keydown);
    window.addEventListener('resize', this.place);
    this.focusFirst();
  },
  beforeDestroy() {
    document.removeEventListener('click', this.outside, true);
    window.removeEventListener('keydown', this.keydown);
    window.removeEventListener('resize', this.place);
  },
  methods: {
    measure() {
      return recentsPanelPlacement({
        column: this.frame.getBoundingClientRect(),
        anchor: this.anchor.getBoundingClientRect(),
        viewportHeight: window.innerHeight,
        mobile: this.mobile,
      });
    },
    place() {
      this.$nextTick(() => {
        this.placement = this.measure();
      });
    },
    focusFirst() {
      (this.$el.querySelector('a') ?? this.$el.querySelector('button'))?.focus();
    },
    keepFocus() {
      if (!this.$el.contains(document.activeElement)) return;

      this.$nextTick(() => {
        if (!this.$el.contains(document.activeElement)) this.focusFirst();
      });
    },
    keydown(event) {
      if (event.key !== 'Escape') return;

      event.stopPropagation();
      this.$emit('close', true);
    },
    focusOut({ relatedTarget }) {
      const stays = [this.$el, this.anchor].some((node) => node?.contains(relatedTarget));

      if (!relatedTarget || stays) return;

      this.$emit('close', false);
    },
    outside({ target }) {
      if (this.$el.contains(target) || this.anchor?.contains(target)) return;

      this.$emit('close', false);
    },
  },
};
</script>
